import { Box, Typography } from '@mui/material';
import VideoLoopComponent from './VideoLoopComponent';

export default function Tab4() {
  return (
    <Box sx={{ mt: 5 }}>
      <Box className="flex justify-center align-center column">
        <Typography variant="h2">Uploaded Documents</Typography>
        <Typography sx={{ textAlign: 'center', fontSize: '18px' }}>
          All your trained documents are conveniently organized in the 'Uploaded Documents' section. Rest assured, your
          documents are securely stored on AWS.
        </Typography>
      </Box>
      <Box sx={{ mt: 5 }}>
        <VideoLoopComponent
          url={
            'https://acma-media-bucket.s3.us-east-2.amazonaws.com/images/brand/medaffairsAI/videos/uploaded-documents.mp4'
          }
        />
      </Box>
    </Box>
  );
}
